import { MapPin, Clock, Car, Building2, Phone, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Hero } from '../../components/Hero';

export function Facilities() {
  return (
    <div>
      <Hero
        title="Our Facilities"
        description="State-of-the-art neurological care in a convenient, accessible location within the Northside Forsyth medical complex."
        image="https://images.unsplash.com/photo-1629909613654-28e377c37b09?auto=format&fit=crop&q=80"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Premier Medical Location</h2>
            <p className="text-gray-600 mb-6">
              Juncos Neuro Consulting is strategically located in Suite 210 of the 1100 Building at the Northside Hospital 
              Forsyth medical complex. While we operate as an independent practice, our location offers patients the 
              convenience and accessibility of a major medical center setting.
            </p>
            <p className="text-gray-600">
              Our modern facility is designed to provide a comfortable, professional environment where patients can 
              receive expert neurological care. The medical complex's comprehensive resources complement our 
              specialized services, ensuring patients have access to a full spectrum of healthcare options when needed.
            </p>
          </div>
          <div className="bg-blue-50 rounded-lg p-8">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Location Benefits</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <Building2 className="h-6 w-6 text-blue-600 mr-3 mt-1" />
                <div>
                  <h4 className="font-semibold text-gray-900">Modern Medical Complex</h4>
                  <p className="text-gray-600">State-of-the-art facilities in a premier healthcare setting</p>
                </div>
              </li>
              <li className="flex items-start">
                <Car className="h-6 w-6 text-blue-600 mr-3 mt-1" />
                <div>
                  <h4 className="font-semibold text-gray-900">Easy Access</h4>
                  <p className="text-gray-600">Convenient parking and wheelchair accessibility</p>
                </div>
              </li>
              <li className="flex items-start">
                <Shield className="h-6 w-6 text-blue-600 mr-3 mt-1" />
                <div>
                  <h4 className="font-semibold text-gray-900">Safety & Security</h4>
                  <p className="text-gray-600">24/7 security and emergency response capabilities</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mb-16">
          <h2 className="text-2xl font-bold text-gray-900 mb-8">Our Office Space</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg p-6 shadow-md">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Comfortable Environment</h3>
              <p className="text-gray-600">
                Our office features a welcoming reception area, private consultation rooms, and 
                state-of-the-art examination facilities designed for patient comfort.
              </p>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-md">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Advanced Technology</h3>
              <p className="text-gray-600">
                Equipped with the latest diagnostic and treatment technology to provide 
                comprehensive neurological care.
              </p>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-md">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Patient Privacy</h3>
              <p className="text-gray-600">
                Designed with privacy in mind, ensuring confidential consultations and 
                treatment sessions.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 rounded-lg p-8 mb-16">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Location & Access</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Address</h3>
                <div className="flex items-start gap-3">
                  <MapPin className="h-6 w-6 text-blue-600 mt-1" />
                  <p className="text-gray-600">
                    1100 Northside Forsyth Dr., Suite 210<br />
                    Cumming, GA 30041
                  </p>
                </div>
              </div>
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Hours of Operation</h3>
                <div className="flex items-start gap-3">
                  <Clock className="h-6 w-6 text-blue-600 mt-1" />
                  <div>
                    <p className="text-gray-600">Monday–Thursday: 9:00 AM – 5:00 PM</p>
                    <p className="text-gray-600">Friday: 9:00 AM – 12:00 PM</p>
                  </div>
                </div>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Contact</h3>
                <div className="flex items-start gap-3">
                  <Phone className="h-6 w-6 text-blue-600 mt-1" />
                  <div>
                    <p className="text-gray-600">Phone: (470) 239-3602</p>
                    <p className="text-gray-600">Fax: (404) 698-3463</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3305.733248549831!2d-84.14462692412832!3d34.065893780599716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f59f798bbe0f95%3A0x8e252b8f85d2ea2f!2s1100%20Northside%20Forsyth%20Dr%2C%20Cumming%2C%20GA%2030041!5e0!3m2!1sen!2sus!4v1709438235044!5m2!1sen!2sus"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="rounded-lg"
              ></iframe>
            </div>
          </div>
        </div>

        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Schedule Your Visit</h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            Experience our state-of-the-art facilities and expert care firsthand. 
            Contact us to schedule your consultation today.
          </p>
          <div className="flex justify-center gap-4">
            <Link
              to="/contact"
              className="bg-blue-600 text-white px-8 py-3 rounded-md font-semibold hover:bg-blue-700 transition-colors"
            >
              Contact Us
            </Link>
            <Link
              to="/patient-info/new-patients"
              className="bg-white text-blue-600 border border-blue-600 px-8 py-3 rounded-md font-semibold hover:bg-blue-50 transition-colors"
            >
              New Patient Information
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}